import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../shared/services/common/common.service';
import { DisplayNotificationService } from '../shared/services/common/notification.service';
import { ReadConfigService } from '../shared/services/common/read-config.service';
import { UsersService } from '../shared/services/common/users.service';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css']
})
export class NewsComponent implements OnInit {
  newsContent: any;
  noNewsText: any;

  constructor(
    private router: Router,
    private usersService: UsersService,
    private commonService: CommonService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService) { }

  ngOnInit() {
    const config = this.readConfigService.getSPNews();
    this.noNewsText = config.NoNewsText;
    this.getNews();
  }

  getNews() {
    this.notificationService.setUpLoading(true);
    const inputData = {
      userInfo: this.usersService.UserInfo()
    };
    this.commonService.getNews(inputData).subscribe((data: any) => {
      if (data && data.statusCode === 200 && data.result) {
        this.newsContent = data.result;
        if (this.newsContent.length > 0) {
          this.newsContent.forEach((element: any) => {
            element.newsDetails = element.newsDetails ?
              element.newsDetails.replace(/<a/g, '<span class="ext"></span><a target="_blank"').replace(/<u/g, '<span').replace(/<\/u>/g, '</span>')
              : element.newsDetails;
          });
        }
      } else if (data && data.statusCode === 403) {
        this.router.navigate(['/forbidden']);
      } else {
        this.notificationService.setErrorNotification();
      }
      this.notificationService.setUpLoading(false);
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.notificationService.setUpLoading(false);
        this.notificationService.setErrorNotification();
      });
  }

  showDialog(id: number) {
    this.router.navigate(['/news-details', id]);
  }
}
